// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  PollingStatus,
} from "./types";


export default __t.row({
  pollingId: __t.u64().primaryKey().name("polling_id"),
  endpointId: __t.u64().name("endpoint_id"),
  get status() {
    return PollingStatus;
  },
  intervalMs: __t.u64().name("interval_ms"),
  maxPolls: __t.u64().name("max_polls"),
  totalPolls: __t.u64().name("total_polls"),
  totalErrors: __t.u64().name("total_errors"),
  consecutiveErrors: __t.u64().name("consecutive_errors"),
  lastStatusCode: __t.u32().name("last_status_code"),
  lastError: __t.string().name("last_error"),
  lastErrorAt: __t.option(__t.timestamp()).name("last_error_at"),
  lastPollAt: __t.option(__t.timestamp()).name("last_poll_at"),
  startedAt: __t.timestamp().name("started_at"),
});
